export const isServer = typeof window === 'undefined';
export const isWeb = !isServer;
export const isNative = false;
export const isIOS = false;
export const isAndroid = false;

// portal types
export const isContractor = false;
export const isAdmin = true;
export const isTenant = false;
export const isPlatform = false;